// Import Bootstrap CSS and JS
import 'bootstrap/dist/css/bootstrap.min.css';
import * as bootstrap from 'bootstrap';
import './styles/theme.css';

// Expose Bootstrap for inline scripts
window.bootstrap = bootstrap;

import { onAuthStateChanged, signInAnonymouslyUser, signInWithGoogle, signOutUser, getIdToken } from './auth.js';
import { db } from './firebase.js';
import { onSnapshot, collection, doc, getDoc } from 'firebase/firestore';

window.URL = window.URL || window.webkitURL;
window.BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder;

// Expose Firestore for inline scripts
window.firebaseUtils = {
    db,
    onSnapshot,
    collection,
    doc,
    getDoc,
    onAuthStateChanged
};

// Auth Logic
onAuthStateChanged(async (user) => {
    const currentPath = window.location.pathname;

    if (user) {
        if (user.isAnonymous) {
            console.log("User is anonymous:", user.uid);
            // Anonymous users are restricted to login page
            if (currentPath !== '/login') {
                window.location.href = '/login';
            }
        } else {
            console.log("User is authenticated:", user.uid);
            
            // Update User Info in Navbar
            const nameEl = document.getElementById('user-name');
            const avatarEl = document.getElementById('user-avatar');
            
            if (nameEl) nameEl.textContent = user.displayName || user.email || 'User';
            
            if (avatarEl) {
                if (user.photoURL) {
                    avatarEl.innerHTML = `<img src="${user.photoURL}" alt="Profile" referrerpolicy="no-referrer" style="width: 100%; height: 100%; object-fit: cover;">`;
                } else {
                    const name = user.displayName || user.email || 'U';
                    const initial = name.charAt(0).toUpperCase();
                    avatarEl.textContent = initial;
                }
            }

            // Sync Session Cookie
            try {
                const idToken = await getIdToken();
                const response = await fetch('/api/sessionLogin', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ idToken })
                });

                if (response.ok) {
                    // Authenticated users go to dashboard
                    if (currentPath === '/login') {
                        const params = new URLSearchParams(window.location.search);
                        const redirectUrl = params.get('redirect') || '/';
                        window.location.href = redirectUrl;
                    }
                } else {
                    console.error("Failed to create session cookie");
                }
            } catch (error) {
                console.error("Error syncing session:", error);
            }
        }
    } else {
        // No user, sign in anonymously for tracking
        console.log("No user, signing in anonymously...");
        signInAnonymouslyUser().catch(error => {
            console.error("Failed to sign in anonymously", error);
        });
    }
});

// Page Handlers
document.addEventListener('DOMContentLoaded', () => {
    // Login Handlers
    const googleBtn = document.getElementById('google-login-btn');

    if (googleBtn) {
        googleBtn.addEventListener('click', async () => {
            try {
                await signInWithGoogle();
            } catch (error) {
                console.error("Google login failed", error);
                alert("Google login failed. Please try again.");
            }
        });
    }


    // Logout Handler
    const logoutBtn = document.getElementById('admin-logout-btn');
    if (logoutBtn) {
        logoutBtn.addEventListener('click', async (e) => {
            e.preventDefault();
            try {
                await signOutUser();
                await fetch('/api/sessionLogout', { method: 'POST' });
                window.location.href = '/login';
            } catch (error) {
                console.error("Logout failed", error);
            }
        });
    }
});
